/**
 * Custom DOM event dispatched whenever `/account/*`'s layout renders — it
 * always re-checks auth fresh (`retrieveCustomerFresh()`, force-dynamic), so
 * it's a reliable signal that login/logout/signup just happened, even when
 * the redirect target is the same URL the form itself lives at (`/account`
 * by default) and `LayoutDataLoader`'s pathname-driven refetch never fires.
 *
 * Kept in its own dependency-free module (mirrors `cart-provider/constants`
 * and `@lib/analytics/constants`'s event names) so the dispatcher doesn't
 * need to import `auth-provider/index.tsx`'s heavier Server Action chain.
 */
export const AUTH_CHANGED_EVENT = 'medusa:authchanged';
